import Vue from 'vue'
import SimpleBar from 'simplebar-vue'
import 'simplebar/dist/simplebar.min.css'

Vue.component('SimpleBar', SimpleBar)
